import { render, staticRenderFns } from "./AddPatientDepartmentNote.vue?vue&type=template&id=50afbfdf&scoped=true"
import script from "./AddPatientDepartmentNote.vue?vue&type=script&lang=js"
export * from "./AddPatientDepartmentNote.vue?vue&type=script&lang=js"
import style0 from "./AddPatientDepartmentNote.vue?vue&type=style&index=0&id=50afbfdf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50afbfdf",
  null
  
)

export default component.exports